"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderReceipt = void 0;
class GetOrderReceipt {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.getOrderReceipt(request);
    }
}
exports.GetOrderReceipt = GetOrderReceipt;
